import { useLanguage } from '@/contexts/LanguageContext';

const SUPPORTED_LANGS = ['en', 'de', 'tr', 'fr', 'ru', 'it', 'es', 'ar'];
const DEFAULT_LANG = 'de';

/**
 * Returns a localized path with the current language prefix.
 * e.g., localePath('/services') => '/de/services'
 */
export const useLocalizedPath = () => {
  const { lang } = useLanguage();

  const localePath = (path: string) => {
    // Remove any existing lang prefix
    const cleanPath = stripLangPrefix(path);
    return `/${lang}${cleanPath === '/' ? '' : cleanPath}`;
  };

  return { localePath };
};

/**
 * Strips the language prefix from a path.
 * e.g., '/de/services' => '/services', '/de' => '/'
 */
export const stripLangPrefix = (path: string): string => {
  const match = path.match(/^\/([a-z]{2})(\/.*)?$/);
  if (match && SUPPORTED_LANGS.includes(match[1])) {
    return match[2] || '/';
  }
  return path;
};

/**
 * Extracts the language from a path, or returns null.
 */
export const getLangFromPath = (path: string): string | null => {
  const match = path.match(/^\/([a-z]{2})(\/|$)/);
  if (match && SUPPORTED_LANGS.includes(match[1])) {
    return match[1];
  }
  return null;
};

export { SUPPORTED_LANGS, DEFAULT_LANG };
